import imageFile2 from './Images/img2.jpg';
//import CcilLogo from './Images/CCIL logo elements-04.png';
import CcilLogo from './Images/CCIL English.png';

import PrivacyPolicyPdf from './Documents/Privacy Policy.pdf';
import CookieStatementPdf from './Documents/Cookie Statement.pdf';
import { VscServerProcess } from 'react-icons/vsc';
import { VscFeedback } from 'react-icons/vsc';
import Navbar from './Navbar';
import './Home.css';
import RegisterInternalUser from './Registration/RegisterInternalUser';

//
import * as React from 'react';
import { GrNext } from "react-icons/gr"; //'>' icon

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';

function HomePage() {
   
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');
    const navigate = useNavigate();

    //RegisterDialog
    const [openRegisterDialog, setOpenRegisterDialog] = React.useState(false);

    const asyncGetTokenByUserName = async () => {
       
            const strLoginInternalUserUrl = 'home/loginInternalUser';
            console.log("strLoginInternalUserUrl = " + strLoginInternalUserUrl);
            await fetch(strLoginInternalUserUrl, {
                method: 'POST'
            }).then(response => {
                //console.log("res", response)
                return response.text()
            }).then(data => {
                //console.log("dataa", data);
                //Logic change..
                if (String(data) !== "") {
                    //var user = '@HttpContext.Session.GetString("EMPCODE")';
                   // asyncGetEmployeeCodeByUsername();
                    sessionStorage.setItem("jwt", data);
                //    window.location.replace("/")
                } else {
                    // enter your logic - when there is an error (eg. error toast)
                    alert("User is not authenticated!")
                }
            })
                ;
        
    }
    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        //RegisterDialog
        if ((window.location.hostname == "grievanceportal-dev.ccilindia.net"
            || window.location.hostname == "grievanceportal.ccilindia.net"
            || window.location.hostname == "localhost")) {
            asyncGetEmployeeCodeByUsernameHeader().then(

            )
        }
       
        
    }, []);
    //For Internal user to set Id in sessionStorage
    const asyncGetEmployeeCodeByUsernameHeader = async () => {
        const strGetEmpCodeUrl = 'home/getEmployeeCode';

        await fetch(strGetEmpCodeUrl, {
            method: 'POST'
        }).then(response => {
            //console.log("res", response)
            if (response.status == 200) {
                return response.text()
            }
            else if (response.status == 204) {
                setOpenRegisterDialog(true)
            }
        }).then(data => {
            if (data) {
                sessionStorage.setItem("InternalUserId", data);
                setOpenRegisterDialog(false);
                let temp = "jwt" in sessionStorage;
                if (!temp
                    && (window.location.hostname == "grievanceportal-dev.ccilindia.net"
                    || window.location.hostname == "grievanceportal.ccilindia.net"
                    || window.location.hostname == "localhost"
                        && "InternalUserId" in sessionStorage
                    ) ){
                    asyncGetTokenByUserName();
                }
                if (open) {
                    const { current: descriptionElement } = descriptionElementRef;
                    if (descriptionElement !== null) {
                        descriptionElement.focus();
                    }
                }
                /*Show Grievance Summary dialog for Internal User*/
            //    handleClickOpen()
            }
        })
    }
    const handleCloseRegisterDialog = () => {
        setOpen(false);
    };
    const [registered, setRegistered] = useState('');
    //For getting response from Register component
    const childToParent = (childdata) => {
        setOpenRegisterDialog(!childdata)//Close dialog if Register Component returns True
        setRegistered(childdata)
    }
    return (
        <div>
            <Navbar />
            {sessionStorage.getItem("InternalUserId") == null &&
                <Dialog
                    fullWidth='false'
                    maxWidth='sm'
                    open={openRegisterDialog}
                    onClose={handleCloseRegisterDialog}
                    scroll='paper'
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description" >
                    <DialogTitle id="scroll-dialog-title">Register</DialogTitle>
                    <DialogContent dividers={scroll === 'paper'} tabIndex={-1} id="scroll-dialog-description">
                        <RegisterInternalUser childToParent={childToParent} />
                    </DialogContent>
               
                </Dialog>
            }
            <h1 className="title">Grievance Redressal Portal</h1>

            
            <div class="container my-5">
              
                {/*<!-- Section: Block Content -->*/}
                <section class="dark-grey-text">

                    <h3 class="align-left  font-weight-bold mb-4 pb-2">About Grievance Management System</h3>
                    <hr/>
                    {/*<!-- Grid row -->*/}
                    <div class="row">

                        {/*<!-- Grid column -->*/}
                        <div class="col-lg-3 mb-lg-0 mb-4">

                            <img src={CcilLogo} class="img-fluid rounded z-depth-1 small-logo" alt="Sample project image"></img>
                        </div>
                        {/*<!-- Grid column -->*/}

                        {/*<!-- Grid column -->*/}
                        <div class="col-lg-7">

                            <ul class="list-unstyled fa-ul mb-0">
                                <li class="d-flex justify-content-center pl-4">
                                    <span class="fa-li"><i class="fas fa-book fa-2x cyan-text"></i></span>
                                    <div>
                                        <h5 class="font-weight-bold mb-3">Vision</h5>
                                        <p class="text-muted">"To be a resilient and compliant Financial Market Infrastructure offering secure and innovative products in a cost-effective and efficient manner."</p>
                                    </div>
                                </li>

                            </ul>

                        </div>
                        {/*<!-- Grid column -->*/}
                    </div>
                    {/*<!-- Grid row -->*/}

                    <hr class="my-5" />
                    {/*<!-- Grid row -->*/}
                    <div class="row">

                        {/*<!-- Grid column -->*/}
                        <div class="col-lg-3 mb-lg-0 mb-4">
                            <VscServerProcess class="br-icon img-fluid rounded z-depth-1 fa-9x red-text" />
                        </div>

                        <div class="col-lg-7">
                            <ul>
                                <li class="d-flex justify-content-center pl-4">
                                    <span class="fa-li"><VscServerProcess class="fa-2x red-text" /></span>
                                    <div>
                                        <h5 class="font-weight-bold mb-3">Process</h5>
                                        <p class="text-muted">The grievance can be filed under the appropriate category(Department). Once grievance has been submitted, a ticket number will be generated. Customer can track the status of the grievance with the help of ticket number. The generated grievance will be addressed by the competent department within a period of defined working days.</p>
                                    </div>
                                </li>

                            </ul>

                        </div>
                        {/*<!-- Grid column -->*/}

                    </div>
                    {/*<!-- Grid row -->*/}
                    <hr class="my-5" />
                    {/*<!-- Grid row -->*/}
                    <div class="row">

                        {/*<!-- Grid column -->*/}
                        <div class="col-lg-3 mb-lg-0 mb-4">
                            <VscFeedback class="br-icon img-fluid rounded z-depth-1 fa-9x red-text" />
                        </div>

                        <div class="col-lg-7">
                            <ul>
                                <li class="d-flex justify-content-center pl-4">
                                    <span class="fa-li"><VscFeedback class="fa-2x red-text" /></span>
                                    <div>
                                        <h5 class="font-weight-bold mb-3">Feedback</h5>
                                        <p class="text-muted">Customer/Citizen can provide feedback for the quality of resolution of grievance through a "satisfied" / "Dissatisfied" option.</p>
                                    </div>
                                </li>

                            </ul>

                        </div>
                        {/*<!-- Grid column -->*/}

                    </div>
                    {/*<!-- Grid row -->*/}

                    <hr class="my-5" />

                </section>
                {/*<!-- Section: Block Content -->*/}
            </div>
            <footer style={{justifyContent:"center"}} className="footer max-height padding-footer padding-footer-bottom  text-center bg-primary-col  ">
                <div className="text-white">
                    Copyright &copy; 2024 CCIL | Designed and developed by CCIL-IT | <a style={{ color: "yellow" }} href={PrivacyPolicyPdf} rel="noopener noreferrer" target="_blank" > Privacy Policy </a>
                    and  <a style={{ color: "yellow" }} href={CookieStatementPdf} rel="noopener noreferrer" target="_blank"> Cookie Statement </a> 
                    
                    <br/>
                    Review our <a style={{ color: "yellow" }} target="_blank"> Grievance Policy </a> for detailed guidelines on submission and resolution procedures.
                </div>
            </footer>
        </div>
    );
}
export default HomePage;